import { ADVISOR_SUPPORT_EMAIL } from "@modules/advisory-team/constants";
import { Button } from "@earned/core";
import { useCallback } from "react";
import { advisorMeetingSetup } from "@common/utils";
import { useUser } from "@auth0/nextjs-auth0/client";
import { useHousehold, useMeClient } from "@common/queries";

const AdvisorTeamActionButtons = ({
  advisorTeamMemberInfo,
  isLockedAdvisoryTeam,
}: {
  advisorTeamMemberInfo?: Forme.AdvisorWithRole;
  isLockedAdvisoryTeam: boolean;
}) => {
  const { user } = useUser();
  const { data: household } = useHousehold();
  const { data: client } = useMeClient();
  const onClickScheduleCall = useCallback(() => {
    const meetingProps = advisorMeetingSetup(
      household?.primaryWealthAdvisor,
      user as Forme.Claims,
      client
    );
    window.Calendly.initPopupWidget({
      ...meetingProps,
      ...{
        url: isLockedAdvisoryTeam
          ? meetingProps.url
          : advisorTeamMemberInfo?.calendlyUrl,
      },
    });
  }, [user, household, client, advisorTeamMemberInfo, isLockedAdvisoryTeam]);
  return (
    <div className="my-4 grid min-h-10 w-full grid-cols-1 gap-3 sm:grid-cols-2">
      {advisorTeamMemberInfo?.calendlyUrl && (
        <Button variant="secondary" onClick={onClickScheduleCall}>
          Schedule Call
        </Button>
      )}
      <Button
        variant="primary"
        href={`mailto:${advisorTeamMemberInfo?.email ?? ADVISOR_SUPPORT_EMAIL}`}
      >
        Email
      </Button>
    </div>
  );
};

export default AdvisorTeamActionButtons;
